import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import _ from 'lodash';
import { formatBytes } from 'src/app/helper/byteFormattingHelper';
import { LanguageType } from 'src/app/samwebDescription/samweb/settings/language-types';
import { SettingsState } from 'src/app/store/settings/settings.state';
import { MessageInfo } from '../../samwin-mail-list/message-info';
import { SamwinMessageListStateSelectors } from '../../samwin-mail-list/samwin-message-list.selectors';
import { EmailBehaviourState, EmailBehaviourStateModel } from './email-behaviour.state';

@Injectable()
export class EmailBehaviourStateSelectors {
   constructor() {}

   @Selector([EmailBehaviourState.getEmailSize, SettingsState.getCurrentLanguage])
   public static getEmailSizeFormatted(getEmailSize: (messageId: string) => number, language: LanguageType) {
      return (messageId: string) => {
         const emailSize = getEmailSize(messageId);
         const result = formatBytes(emailSize, 2, language.angularTranslationKey);
         return result;
      };
   }

   @Selector([EmailBehaviourState, SamwinMessageListStateSelectors.getAllLoadedMessages])
   public static getEmailData(state: EmailBehaviourStateModel, messages: MessageInfo[]) {
      return (messageId: string) => {
         const email = state[messageId];
         const emailDateTime = _(messages.filter((message) => message.messageId === messageId)).head().timestamp;
         return { messageId: email.messageId, timeStamp: emailDateTime, email: email.email, attachments: email.attachments };
      };
   }
}
